import PropTypes from 'prop-types';
import MiniSpinner from '../MiniSpinner/MiniSpinner';
import classes from './DownloadButton.module.css';

const DownloadButton = ({
  downloadable,
  loadingDownload,
  onDownload,
  color,
  text,
}) =>
  downloadable && (
    <button
      className={classes.button}
      type="button"
      onClick={onDownload}
      style={{ backgroundColor: color }}
    >
      {loadingDownload ? <MiniSpinner /> : text}
    </button>
  );

DownloadButton.propTypes = {
  downloadable: PropTypes.bool,
  loadingDownload: PropTypes.bool,
  onDownload: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  text: PropTypes.string,
};

DownloadButton.defaultProps = {
  downloadable: true,
  loadingDownload: false,
  text: 'Download  ',
};

export default DownloadButton;
